//
//
//
//
//
//

import { setOwnKey } from '@/tools'
export default {
  props: {},
  data() {
    return {
      question: {
        v_ownId: setOwnKey(),
        v_active: false,
        v_label: '多选题',
        type: 'checkbox',
        displayIndex: true,
        title: '请选择以下选项 (多选)',
        required: true,
        voteVisible: false,
        selectRangeMin: 0,
        selectRangeMax: 0,
        scoreType: '1',
        scoreTotal: 0,
        column: 1,
        uploadArrow: true,
        uploadArrowRequired: false,
        logic: {
          blocks: {
            typeBlock: 'all',
            list: [],
          },
        },
        options: [
          {
            v_ownId: setOwnKey(),
            v_editable: false,
            text: '选项1',
            score: 0,
            exclude: false,
            excludeList: [],
            blankVisible: false,
            blankRule: 'ignore',
            blankMaxLengthVisible: false,
            blankMinLength: null,
            blankMaxLength: null,
            blankRequired: false,
          },
          {
            v_ownId: setOwnKey(),
            v_editable: false,
            text: '选项2',
            score: 0,
            exclude: false,
            excludeList: [],
            blankVisible: false,
            blankRule: 'ignore',
            blankMaxLengthVisible: false,
            blankMinLength: null,
            blankMaxLength: null,
            blankRequired: false,
          },
        ],
      },
    }
  },
  methods: {
    chooseItem() {
      this.$emit('choose', this.question)
    },
  },
}
